import type { Node } from 'prosemirror-model';
import type { Command } from 'prosemirror-state';

import type { VideoNodeAttrs } from '../nodes/video-node.types';

export const updateVideoAttributesCommand = (
  videoNode: Node,
  { src, width, height }: VideoNodeAttrs,
): Command =>
  function (state, dispatch) {
    const { doc } = state;

    const tr = state.tr;
    doc.descendants((node, pos) => {
      if (node === videoNode) {
        tr.setNodeAttribute(pos, 'src', src);
        tr.setNodeAttribute(pos, 'width', width);
        tr.setNodeAttribute(pos, 'height', height);
      }
    });
    if (!tr) return false;
    if (dispatch) dispatch(tr);
    return true;
  };
